<template>
  <v-dialog v-model="visible" :lazy="true" width="350px">
    <v-card>
      <AgentCard :userId="agentId" :userProfile="agentProfile" :tenantSubdomain="tenantSubdomain" :showCloseButton="true" />
    </v-card>
  </v-dialog>
</template>

<script>
  import AgentCard from './AgentCard.vue'
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'AgentCardDialog',
    components: {
      AgentCard
    },
    data() {
      return {
        visible: false,
        agentId: '',
        agentProfile: {},
        tenantSubdomain: ''
      }
    },
    computed: {
      ...mapGetters([
        'agentCardDialog'
      ])
    },
    watch: {
      agentCardDialog(value) {
        console.log('agentCardDialog change', value)
        this.visible = value.visible || false
        this.agentId = value.agentId || ''
        this.agentProfile = value.agentProfile || {}
        this.tenantSubdomain = value.tenantSubdomain || ''
      }
    },
    methods: {
      ...mapMutations([
        'closeAgentCardDialog'
      ]),

      close() {
        this.closeAgentCardDialog()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/elements/AgentCardDialog.vue